import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutPayeeDriversQuickInfo extends Layout {
	labelNoDrivers: Label;
	panelPayeeDrivers: Panel;
	sourcePayeeDrivers: DataSource;
	tableDrivers: Table;
}
